import { render } from "./BarangKeluar.vue?vue&type=template&id=c8139d22&scoped=true"
import script from "./BarangKeluar.vue?vue&type=script&lang=js"
export * from "./BarangKeluar.vue?vue&type=script&lang=js"

import "./BarangKeluar.vue?vue&type=style&index=0&id=c8139d22&scoped=true&lang=css"
import "./BarangKeluar.vue?vue&type=style&index=1&id=c8139d22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8139d22"]])

export default __exports__